import * as React from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

import MaskInput from '../shared/MaskInput'

interface IPhoneInputProps {
  phone: string
  onChange: React.ChangeEventHandler
  onBlur: (e: any) => void
  error?: boolean
}

const PhoneInput: React.SFC<IPhoneInputProps> = ({
  phone,
  onChange,
  onBlur,
  error
}) => (
  <FormControl fullWidth required error={error}>
    <InputLabel>Phone</InputLabel>
    <Input
      name="phoneNumber"
      fullWidth
      autoComplete="tel"
      value={phone}
      onChange={onChange}
      onBlur={onBlur}
      inputComponent={MaskInput}
      inputProps={{
        mask: [
          '(',
          /[1-9]/,
          /\d/,
          /\d/,
          ')',
          ' ',
          /\d/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
          /\d/,
          /\d/
        ]
      }}
    />
  </FormControl>
)

export default PhoneInput



// WEBPACK FOOTER //
// ./src/components/shared/PhoneInput.tsx